/**
 * Learning Progress Bar — פס התקדמות במסלול
 * Mirrors the questionnaire ProgressBar's a11y contract: a real progressbar role
 * with numeric bounds, plus the same information as visible text (never colour or
 * width alone).
 */

interface LearningProgressBarProps {
  completedCount: number
  totalLessons: number
  percent: number
}

export default function LearningProgressBar({
  completedCount,
  totalLessons,
  percent,
}: LearningProgressBarProps) {
  return (
    <div>
      <div className="flex items-center justify-between text-sm">
        <span className="font-medium text-gray-900">ההתקדמות שלך</span>
        <span className="text-gray-700">
          {completedCount} מתוך {totalLessons} נושאים
        </span>
      </div>
      <div
        className="mt-2 h-3 w-full overflow-hidden rounded-full bg-gray-200"
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="התקדמות במסלול הלמידה"
        aria-valuetext={`${percent} אחוז, ${completedCount} מתוך ${totalLessons} נושאים`}
      >
        <div
          className="h-full rounded-full bg-primary-600 transition-all duration-500"
          style={{ width: `${Math.min(100, Math.max(0, percent))}%` }}
        />
      </div>
    </div>
  )
}
